import { ONBOARDING_STEP } from 'src/data/onboarding';
import { Z_INDEX } from 'src/data/ui';

import { HiddenAudiencesHint } from '../components/HiddenAudiencesHint';
import { SPOTLIGHT_TYPE } from '../components/Spotlight';
import { InsightsPanelHint } from '../views/InsightsPanelHint';
import { ScoreOnboardingHint } from '../views/ScoreHint';

export const STEPS_DOCUMENT_DATA = [
  {
    id: ONBOARDING_STEP.documentVariationScore,
    target: '[data-active-view="true"] [data-onboarding="Score"]',
    contentClass: ScoreOnboardingHint,
    options: {
      placement: 'left-center',
      tooltipMargin: 30,
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.circle, padding: 15 }],
      zIndex: 1200,
    },
  },
  {
    id: ONBOARDING_STEP.documentInsightsPanel,
    target: '[data-onboarding="InsightsPanel"]',
    contentClass: InsightsPanelHint,
    options: {
      placement: 'left-center',
      tooltipMargin: 30,
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rectangle, padding: 0 }],
      arrow: true,
    },
  },
  {
    id: ONBOARDING_STEP.documentSuggestedPersonasNotify,
    target: '[data-onboarding="PersonaMoreButton"]',
    contentClass: HiddenAudiencesHint,
    content: {
      dontShowAgain: true,
    },
    options: {
      placement: 'top-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded, padding: 0 }],
      zIndex: Z_INDEX.onboarding,
    },
  },
];
